import { TextField } from "@material-ui/core";
import NumberFormat from "react-number-format";
import { useState, useEffect } from "react";
import { cloneDeep } from "lodash";

function NumberFormatCustom(props) {

    const { inputRef, column, onChange, ...other } = props;

    const onChangeValue = ( value, sourceInfo ) => {

        if ( onChange ) {

            // change value only if user changed value ( prevent propagation of change from property value )

            if ( sourceInfo?.source === "event" ) {

                let event = cloneDeep ( sourceInfo.event );

                event.target.value = value.floatValue;
                onChange ( sourceInfo.event );

            }

        }

    }
    const thousandSeparator = column ? ( column.thousandSeparator !== undefined ? column.thousandSeparator : true ) : true;
    const decimalScale = column ? ( column.decimalScale !== undefined ? column.decimalScale : 4 ) : 4;
    const allowNegative = column ? ( column.allowNegative !== undefined ? column.allowNegative : true ) : true;

    return (
        <NumberFormat
            {...other}
            prefix={column?.numberPrefix}
            getInputRef={inputRef}
            onValueChange={onChangeValue}
            thousandSeparator={thousandSeparator}
            allowNegative={allowNegative}
            decimalScale={decimalScale}
        />
    );
}

function FormItemFloat(props) {

    const { column, InputLabelProps, value, onChange, focusRef, ...others } = props;
    
    const [floatValue, setFloatValue] = useState (  );

    useEffect(() => {

        let decimalScale = column ? ( column.decimalScale !== undefined ? column.decimalScale : 4 ) : 4;
        let initialValue = parseFloat ( value );
    
        // 빈 값은 빈 칸으로 보인다 — 0 으로 보이면 필수 항목 판정과 어긋난다
        setFloatValue ( isNaN ( initialValue ) ? "" : initialValue );

    }, [column, value])

    let textFieldProps = {

        InputLabelProps: {
            shrink: true,
            ...InputLabelProps,
        },

        onChange: ( event ) => {

            let floatValue = parseFloat ( event.target.value );

            setFloatValue ( floatValue );

            if ( onChange ) {

                setTimeout ( onChange ( floatValue ), 0 );

            }

        },
        ...others,
    };

    if (column.InputLabelProps) {
        textFieldProps.InputLabelProps = { ...textFieldProps.InputLabelProps, ...column.InputLabelProps };
    }

    if (column.required) {
        textFieldProps.required = true;
    }

    if (column.variant) {
        textFieldProps.variant = column.variant;
    }

    if (column.inputProps) {
        textFieldProps.inputProps = column.inputProps;
    }

    if (column.InputProps) {
        textFieldProps.InputProps = { ...column.InputProps, inputComponent: NumberFormatCustom };
    } else {
        textFieldProps.InputProps = { inputComponent: NumberFormatCustom };
    }

    if (column.InputProps) {
        textFieldProps.InputProps = column.InputProps;
    }

    if (column.style) {
        textFieldProps.style = column.style;
    }

    return <TextField value={floatValue} inputRef={focusRef} {...textFieldProps} />;

}

export default FormItemFloat;
